module.exports = __webpack_public_path__ + "c99a18c1d8d117249ac850d10f1c8c3c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-21.png
// module id = 2911
// module chunks = 0